import {PixiApplicationController} from '../PixiApplicationController';
import {StackSelector} from '../StackSelector';
import {DynamicData} from '../../data/DynamicData';
import {StaticData} from '../../data/StaticData';

export class UnselectByMouseStoppedController
{
    private static timeout: number;

    /**
     * Инициализация
     */
    static start(): void {
        PixiApplicationController.app.view.addEventListener('pointermove', () => UnselectByMouseStoppedController.resetTimer());
    }

    /**
     * Сбрасываем таймер
     */
    static resetTimer(): void {
        window.clearTimeout(UnselectByMouseStoppedController.timeout);
        UnselectByMouseStoppedController.timeout = window.setTimeout(UnselectByMouseStoppedController.fire, StaticData.notActiveMouseUnselectTimeout);
    }

    /**
     * снимаем выделение с объектов стола при неактивности мыши более 5000 миллисекунд
     */
    static fire(): void {
        DynamicData.dragSomething || StackSelector.selectedStacks.length && StackSelector.unselectAll();
    }
}
